function isUndefinedResponse(error) {
    return (
        error
        && (error.response === undefined || error.response === 'undefined')
        && (error.message === undefined || error.message !== 'canceled')
    );
}

export default isUndefinedResponse;
